import { colors } from 'component-library/styles/colors';
import { device } from 'component-library/styles/device';
import React, { FC, PropsWithChildren } from 'react';
import styled, { css, StyledComponentProps } from 'styled-components';

import { Icon, IconName } from '../icons/Icon';
import { bodyStyles, BodyStylesProps } from '../typography/Body';

export enum ButtonColor {
  NavyBlue = 'navyBlue',
  Peach = 'peach',
  Teal = 'teal',
  Transparent = 'transparent',
}

export interface PrimaryButtonProps
  extends StyledComponentProps<
    'button',
    Record<string, any>,
    Record<string, any>,
    never
  > {
  small?: boolean;
  buttonColor: ButtonColor;
  withCaret?: boolean;
  fullWidth?: boolean;
}

interface InternalPrimaryButtonProps
  extends PrimaryButtonProps,
    BodyStylesProps {}

const buttonStyles = css<InternalPrimaryButtonProps>`
  position: relative;
  cursor: pointer;
  z-index: 2;
  align-items: center;
  background: ${({ buttonColor }) => colors[buttonColor]};
  border-radius: 100px;
  border: 1px solid ${colors.navyBlue};
  display: flex;
  justify-content: center;
  padding: ${({ small }) => (small ? '15px 39px' : '19px 39px')};
  width: 100%;
  ${bodyStyles}

  &:disabled {
    cursor: not-allowed;
    background: ${colors.grey};
  }

  ${`@media ${device.lg}`} {
    width: ${({ fullWidth = false }) => (fullWidth ? '100%' : 'fit-content')};
  }
`;

const StyledButton = styled.button<InternalPrimaryButtonProps>`
  ${buttonStyles};
`;

export const PrimaryButton: FC<PropsWithChildren<PrimaryButtonProps>> = ({
  children,
  small,
  buttonColor,
  withCaret,
  ...rest
}) => (
  <StyledButton
    {...rest}
    small={small}
    buttonColor={buttonColor}
    color={
      buttonColor === ButtonColor.NavyBlue ? colors.white : colors.navyBlue
    }
    variant={small ? 4 : 3}
    medium
  >
    {children}
    {withCaret && (
      <Icon
        color={
          buttonColor === ButtonColor.NavyBlue ? colors.white : colors.navyBlue
        }
        name={IconName.CaretRight}
        marginLeft={8}
      />
    )}
  </StyledButton>
);
